import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';

/**
 * Rotary Nedir? — URL: /what-is-rotary
 */
export function WhatIsRotaryPage() {
    const { t } = useTranslation();

    const bodyParagraphs = useMemo(() => {
        const raw = t('whatIsRotary.bodyParagraphs', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    const principles = useMemo(() => {
        const raw = t('whatIsRotary.principles', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('whatIsRotary.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.whatIsRotary')}
            />
            <SubpageLayout
                title={t('whatIsRotary.title')}
                subtitle={t('whatIsRotary.subtitle')}
                contentClassName="what-is-rotary-page"
            >
                <div className="what-is-rotary-prose">
                    <p className="what-is-rotary-lead mb-0">
                        {t('whatIsRotary.lead')}
                    </p>
                    {bodyParagraphs.map((text, i) => (
                        <p key={i} className="what-is-rotary-prose-p mb-0">
                            {text}
                        </p>
                    ))}
                    <p className="what-is-rotary-prose-p what-is-rotary-principles-intro mb-0">
                        {t('whatIsRotary.principlesIntro')}
                    </p>
                    <ul className="what-is-rotary-principles list-unstyled mb-0">
                        {principles.map((item, i) => (
                            <li
                                key={`${i}-${item.slice(0, 24)}`}
                                className="what-is-rotary-principles-item"
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </SubpageLayout>
        </>
    );
}
